import React, { ReactNode, useState } from 'react';
import styles from './input.module.scss';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { prettyDate } from '../../utils/strings';

interface IInput {
  label: ReactNode;
  id: string;
  placeholder?: string;
  icon?: ReactNode;
  ending?: ReactNode;
  type: string;
  name: string;
  value?: string;
  valueDate?: Date | Date[] | null | undefined;
  pattern?: string;
  required?: boolean;
  disabled?: boolean;
  checked?: boolean;
  calendar?: boolean;
  inputmode?: any;
  onKeyPress?: any;
  onChange?: (e: React.ChangeEvent<any>) => void;
}
const CInput = (props: IInput) => {
  const [calendarVisible, setVisibility] = useState(false);
  const { calendar, icon, ending, ...inputProps } = props;

  return (
    <section
      className={
        props.type !== 'radio' && props.type !== 'checkbox'
          ? styles.section
          : styles.sectionRadio
      }
      onClick={() => props.calendar && setVisibility(!calendarVisible)}
      // onMouseLeave={() => props.calendar && setVisibility(false)}
    >
      <label
        htmlFor={props.id}
        className={styles.label}
        onClick={e =>
          (props.type === 'radio' || props.type === 'checkbox') &&
          props.onChange &&
          props.onChange(e)
        }
      >
        {props.label}
      </label>
      {props.icon && <span className={styles.icon}>{props.icon}</span>}
      {props.ending && props.ending}
      {props.type === 'textarea' ? (
        <textarea
          /* styling with icon / without icon  */
          className={styles.textarea}
          {...props}
        >
          {props.value}
        </textarea>
      ) : (
        <input
          /* styling with icon / without icon  */
          className={props.icon ? styles.inputWI : styles.input}
          {...inputProps}
          lang='ro'
          // ref={textInput}
          data-content={
            props.value
              ? prettyDate(
                  moment(props.value, 'YYYY-MM-DD').format('DD MMMM YYYY')
                )
              : ''
          }
        />
      )}
    </section>
  );
};

export default CInput;
